









import { Component, Prop, Vue } from 'vue-property-decorator';
import { Department, departmentApis } from '@/api';
import * as _ from 'lodash';

@Component
export default class DepartmentSelectM extends Vue {
  @Prop({ required: true }) value!: number;
  localValue: number | string = -1;
  debounceSearch!: (name: string) => void;
  departments: Array<Department> = [];

  created() {
    this.debounceSearch = _.debounce(this.remoteSearch, 150);
    this.localValue = this.value;
    if (this.localValue > 0) {
      this.search(this.localValue.toString());
    }
  }

  private search(search: string) {
    departmentApis.search(search).then(departments => {
      this.departments = departments;
    });
  }

  async remoteSearch(value: string) {
    this.search(value);
  }

  handleChoice(d: Department) {
    this.localValue = d.name;
    this.$emit('input', d.id);
    this.departments = [];
  }
}
